import React from 'react';
import PropTypes from 'prop-types';

// Stage 3.2 (Enterprise Design Foundation & Layout Standardization): a single, reusable content
// card for grouping a page section — header/body/footer slots over the .ent-card* classes defined
// in themes.scss, which themselves build on the existing .ent-panel treatment (background/radius/
// shadow) rather than replacing it. Purely presentational — no existing page consumes this yet;
// future Stage 3 page sprints (Home, Registration, Wizard, Dashboard, etc.) opt in to it directly.
const Card = ({ header, footer, className, children }) => (
  <div className={`ent-card${className ? ` ${className}` : ''}`}>
    {header && <div className="ent-card-header ent-card-header-text">{header}</div>}
    <div className="ent-card-body">{children}</div>
    {footer && <div className="ent-card-footer">{footer}</div>}
  </div>
);

Card.propTypes = {
  header: PropTypes.node,
  footer: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node
};

export default Card;
